import { differenceInCalendarDays, isBefore } from "date-fns";

export function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export function calcularValorTotal(data) {
  const acrescimoFloat = data.acrescimo ? parseFloat(data.acrescimo) : 0;
  const descontoFloat = data.desconto ? parseFloat(data.desconto) : 0;
  const valorTotal = parseFloat(data.valor) + acrescimoFloat - descontoFloat;
  if (valorTotal >= 0) {
    return valorTotal;
  }
}

export const converterValorParaPorcetagem = (valor = 0, total = 0) => {
  return (parseFloat(valor) / parseFloat(total)) * 100;
};

export const converterPorcentagemParaValor = (porcentagem = 0, total = 0) => {
  return (parseFloat(porcentagem) / 100) * parseFloat(total);
};

export const calcularValorAPagar = (
  pagamentoAtualizado,
  pagamentosList = [],
  conta
) => {
  const pagamentosReais = pagamentosList.filter(
    (pago) => parseFloat(pago?.valor) > 0
  );
  const totalPago = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return acumulador + parseFloat(objetoAtual?.valor ?? 0);
  }, 0);
  const totalMultaJuros = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return (
      acumulador +
      parseFloat(objetoAtual?.multa ?? 0) +
      parseFloat(objetoAtual?.juros ?? 0)
    );
  }, 0);
  const totalDescontos = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return acumulador + parseFloat(objetoAtual?.desconto ?? 0);
  }, 0);
  return (
    parseFloat(conta?.valor ?? 0) +
    parseFloat(conta?.acrescimo ?? 0) -
    parseFloat(conta?.desconto ?? 0) +
    parseFloat(pagamentoAtualizado?.multa ?? 0) +
    parseFloat(pagamentoAtualizado?.juros ?? 0) -
    parseFloat(pagamentoAtualizado?.desconto ?? 0) -
    totalDescontos +
    totalMultaJuros -
    totalPago
  );
};

export function totalPagamentos(pagamentos) {
  if (pagamentos?.length) {
    return pagamentos.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.valor),
      0
    );
  }
}

export function totalDespesas(pagamentos) {
  let totalizadores = {
    totalDescontos: 0,
    totalJuros: 0,
    totalMulta: 0,
    total: 0,
  };
  if (pagamentos?.length) {
    return pagamentos.reduce((acc, elem) => {
      if (elem.valor > 0) {
        acc.totalDescontos += elem.desconto || 0;
        acc.totalJuros += elem.juros || 0;
        acc.totalMulta += elem.multa || 0;
        acc.total += elem.valor || 0;
      }
      return acc;
    }, totalizadores);
  } else {
    return totalizadores;
  }
}

export function getAtrasoDias(dataVencimento, dataPagamento) {
  const date1 = dataPagamento ? new Date(dataPagamento) : new Date();
  const date2 = dataVencimento ? new Date(dataVencimento) : new Date();
  const diferencaDias = differenceInCalendarDays(date1, date2);
  return diferencaDias <= -1 || isBefore(date1, date2) ? 0 : diferencaDias;
}

export function calcularValorTotalAtualizado(data) {
  if (!data) return;
  const pagamentosReais = data.pagamentos.filter(
    (pago) => parseFloat(pago.valor) > 0
  );
  const totalPago = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return acumulador + parseFloat(objetoAtual.valor ?? 0);
  }, 0);
  const totalMultaJuros = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return (
      acumulador +
      parseFloat(objetoAtual.multa ?? 0) +
      parseFloat(objetoAtual.juros ?? 0)
    );
  }, 0);
  const totalDescontos = pagamentosReais.reduce((acumulador, objetoAtual) => {
    return acumulador + parseFloat(objetoAtual.desconto ?? 0);
  }, 0);
  return (
    parseFloat(data.valor) +
    parseFloat(data.acrescimo ?? 0) -
    parseFloat(data.desconto ?? 0) +
    totalMultaJuros -
    totalDescontos -
    totalPago
  );
}

export function calcularPagamentosParciais(pagamentos) {
  if (!pagamentos) return;
  const pagamentosParciais = pagamentos.reduce((acc, obj) => {
    return acc + parseFloat(obj.valor);
  }, 0);
  return pagamentosParciais;
}

export const addIdUsuario = (listaObjeto, listaIdUsuario) => {
  listaObjeto.forEach(
    (objeto) => {
      const idUsuario = objeto.updateUserId || objeto.insertUserId;
      listaIdUsuario.push(idUsuario);
    }
  );
}

export const addUserNameLista = (listaObjeto, dadosUsuarios) => {
  return listaObjeto.map((objeto) => {
    const usuario = dadosUsuarios.find(
      (item) => {
        const userId = objeto.updateUserId || objeto.insertUserId;
        return item.id == userId;
    });
    objeto.insertUserName = usuario.nome;
    return objeto;
  });
}